import React, { useState, useRef } from 'react';
import { T, TraksConsumer } from '../traks';
import I18N from '../I18N';

export const Year = (props) => {
	const on_change = e => props.set(e.target.value);
	return <input
		type="text"
		pattern="[0-9]*"
		inputMode="numeric"
		maxLength="4"
		style={{width: "4em"}}
		autoComplete="off"
		value={props.value}
		onChange={on_change}
		className={props.className}
	/>
};

export const Month = (props) => {
	let options = [];

	for (let i = 0; i < 12; i++) {
		options.push(
			<option key={i} value={i}>{props.render_static(I18N.month(i))}</option>
		);
	}

	const on_change = (e) => props.set(e.target.value);

	return (
		<select value={props.value} className={props.className} onChange={on_change}>
			<option value="">{props.render_static(<T>Select month</T>)}</option>
			{options}
		</select>
	);
};

export const Day = (props) => {
	let options = [];
	for (let i = 1; i <= 31; i++) {
		options.push(
			<option key={i} value={i}>{i}</option>
		);
	}

	const on_change = (e) => props.set(e.target.value);

	return (
		<select value={props.value} className={props.className} onChange={on_change}>
			<option value="">{props.render_static(<T>Select day</T>)}</option>
			{options}
		</select>
	);
};

const BirthdayPicker = (props) => {
	let today = useRef(new Date());

	let [ yyyy, raw_set_yyyy ] = useState("");
	let [ mm,   raw_set_mm   ] = useState("");
	let [ dd,   raw_set_dd   ] = useState("");
	let [ show, set_show ] = useState(0);

	const set = (new_yyyy, new_mm, new_dd) => {
		let [ actual_yyyy, actual_mm, actual_dd ] = [ yyyy, mm, dd ];
		if (new_yyyy !== null) { raw_set_yyyy(new_yyyy); actual_yyyy = new_yyyy; }
		if (new_mm   !== null) { raw_set_mm(new_mm); actual_mm = new_mm; }
		if (new_dd   !== null) { raw_set_dd(new_dd); actual_dd = new_dd; }

		let y = parseInt(actual_yyyy, 10);
		let today_yyyy = today.current.getFullYear();

		let show = 0;
		let st = null;
		let best_guess_birthdate = null;
		if ((today_yyyy-150) <= y && y <= (today_yyyy-5)) {
			best_guess_birthdate = [y];
			let y18ago = today_yyyy - 18;
			if (y < y18ago) {
				st = 1;
			} else if (y > y18ago) {
				st = -1;
			} else {
				show = 1;
				if (actual_mm.trim().length > 0) {
					let m = parseInt(actual_mm, 10);
					best_guess_birthdate = [y,m+1];
					let cm = today.current.getMonth();
					if (m < cm) {
						st = 1;
					} else if (m > cm) {
						st = -1;
					} else {
						show = 2;
						if (actual_dd.trim().length > 0) {
							let d = parseInt(actual_dd, 10);
							best_guess_birthdate = [y,m+1,d];
							let cd = today.current.getDate();
							if (d <= cd) {
								st = 1;
							} else {
								st = -1;
							}
						}
					}
				}
			}
		}

		set_show(show);
		props.set(st === 1);
		props.set_join_game_payload({"set_birthdate": best_guess_birthdate});
	};

	const set_yyyy = (new_yyyy) => set(new_yyyy, null,   null);
	const set_mm   = (new_mm)   => set(null,     new_mm, null);
	const set_dd   = (new_dd)   => set(null,     null,   new_dd);

	return (
		<div>
			<span className="ad_little_larger_txt"><b><T>Year of birth (e.g. 1997):</T></b></span>&nbsp;<div className="d-flex pb-3"><img src="/gfx/direction-right-icon-0.svg" style={{width: "24px"}} alt="arrow"/>&nbsp;<Year className={props.className} value={yyyy} set={set_yyyy}/></div>
			{show > 0 &&
				<React.Fragment>
					<div className="ad_little_larger_txt pb-3"><b><T>Month:</T></b><TraksConsumer><Month className={props.className} value={mm} set={set_mm}/></TraksConsumer></div>
					{show > 1 &&
						<React.Fragment>
							<span className="ad_little_larger_txt"><b><T>Day:</T></b></span><TraksConsumer><Day className={props.className} value={dd} set={set_dd}/></TraksConsumer>
						</React.Fragment>
					}
				</React.Fragment>
			}
		</div>
	);
};

export default BirthdayPicker;



// WEBPACK FOOTER //
// ./src/c/BirthdayPicker.js